const PRICE_TYPES = [
  {
    id: 'total-price',
    label: 'Total T',
    value: 'price',
  },
  {
    id: 'monthly-price',
    label: 'Monthly T',
    value: 'monthly-price',
  },
];

const PRICE_REDUCED_KEY = 'price-reduced';

export { PRICE_TYPES, PRICE_REDUCED_KEY };
